module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Bath-d867221883084ec0b5598d4b82a29ce5.svg";